/**
 * Wire error for the spotlight RPCs, broker and admin
 * (agent_docs/backend/wire-error-standard.md; spec cova-feed/2026-10-09-001
 * §5.2): errorCode + safe message + traceId + optional SanitizedCause.
 *
 * The codes are the states the popup and the composer's Stage have to
 * DISTINGUISH. Internal errors (FeedDbError, FeedServiceError) NEVER appear in
 * a contract union; handlers map them here. Codes are APPEND-ONLY once shipped.
 *
 * FRONTEND-SAFE: the contracts import it, and so does the Stage's re-show
 * branch.
 */
import { defineWireError } from "@/shared/error-diagnostics/wire"

export class FeedSpotlightWireError extends defineWireError<FeedSpotlightWireError>()(
  "FeedSpotlightWireError",
  [
    /** Not published, not enabled, or a reply. One code for all three, as the article reader. */
    "FEED_SPOTLIGHT_NOT_FOUND",
    /** The caller's button, re-resolved on the server, is open or skip. */
    "FEED_SPOTLIGHT_NOT_REQUESTABLE",
    /** No covaUserId on the identity: the feed's existing requireCovaUserId rule. */
    "FEED_SPOTLIGHT_ACCOUNT_INCOMPLETE",
    /** Admin: a live spotlight's content changed and the save did not choose who sees it. */
    "FEED_SPOTLIGHT_RESHOW_REQUIRED",
    /** Admin validation. Content-free: names the rule, never echoes the value. */
    "FEED_SPOTLIGHT_INVALID",
    /** Terminal net. */
    "FEED_SPOTLIGHT_INTERNAL",
  ],
) {}
